var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"featured"},[_c('img',{staticClass:"image",attrs:{"src":_vm.imageUrl,"alt":""}}),_c('div',{staticClass:"content"},[_c('h3',[_vm._v(_vm._s(_vm.title))]),_c('span',[_vm._v(_vm._s(_vm.subtitle))])]),_c('span',{staticClass:"keyword",style:({'background-color' : _vm.keywordColor})},[_vm._v(_vm._s(_vm.keyword))])])
}
var staticRenderFns = []

export { render, staticRenderFns }